<mat-sidenav-container hasBackdrop="true" class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0">
    <div class="mx-auto flex w-full flex-wrap p-4">
        <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
            <div>
                <div class="flex items-center gap-1">
                    <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
                        <button mat-icon-button color="primary">
                        <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
                        </button>
                    </div>
                    <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
                        <div class="p-4">
                        <p>
                            Corrige ubicaciones en el mapa. Actualiza coordenadas 
                            de clientes o puntos visitados cuando están mal posicionados. 
                            Úsalo para mejorar ruteo y tiempos de visita/entrega.
                        </p>
                        </div>
                    </mat-menu>
                    <h2 class="text-xl font-semibold leading-8 tracking-tight">
                        Actualizar GPS
                    </h2>
                </div>
                <div class="text-sm text-secondary font-medium tracking-tight">
                    Procesa solicitudes para la actualización de GPS en los <b>socios de negocio</b>.
                </div>
            </div>
            <!-- Header -->
            <div class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between">
                <div class="flex shrink-0">
                    <!-- Title -->
                    <!--<div class="text-3xl font-extrabold tracking-tight">
          {{'BUSINESS_PARTNER.BP' | transloco }}
        </div>-->
                <app-status-filters [selectedStatuses]="selectedStatuses" [showStatus]="[0,1]"
                [typeFilter]="'gps'" (selectionFilterApply)="findAllWithCount()">
                </app-status-filters>
                </div>
                <!-- Actions -->
                <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">

                    <div style="display:inline-flex">
                        <button mat-icon-button [matMenuTriggerFor]="importMenu" matTooltip="Importar/Exportar archivo">
                            <mat-icon>
                                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100"
                                    viewBox="0,0,256,256">
                                    <g fill="#4f46e5" fill-rule="nonzero" stroke="none" stroke-width="1"
                                        stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10"
                                        stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none"
                                        font-size="none" text-anchor="none" style="mix-blend-mode: normal">
                                        <g transform="scale(5.12,5.12)">
                                            <path
                                                d="M30,26v9h-4.18c0.12,-0.38 0.18,-0.78 0.18,-1.2v-7.8zM30,37v9h-13c-1.65,0 -3,-1.35 -3,-3v-5h7.8c1.03,0 1.98,-0.37 2.71,-1zM32,26h16v9h-16zM32,37h16v6c0,1.65 -1.35,3 -3,3h-13zM30,15v9h-4v-7.8c0,-0.42 -0.06,-0.82 -0.18,-1.2zM32,15h16v9h-16zM30,4v9h-5.49c-0.73,-0.63 -1.68,-1 -2.71,-1h-7.8v-5c0,-1.65 1.35,-3 3,-3zM48,7v6h-16v-9h13c1.65,0 3,1.35 3,3zM21.8,36h-17.6c-1.215,0 -2.2,-0.985 -2.2,-2.2v-17.6c0,-1.215 0.985,-2.2 2.2,-2.2h17.6c1.215,0 2.2,0.985 2.2,2.2v17.6c0,1.215 -0.985,2.2 -2.2,2.2zM7.968,19l3.494,5.978l-3.831,6.022h2.863l2.521,-4.716l2.533,4.716h2.821l-3.769,-6l3.685,-6h-2.675l-2.455,4.505l-2.323,-4.505z">
                                            </path>
                                        </g>
                                    </g>
                                </svg>
                            </mat-icon>
                        </button>
                        <mat-menu #importMenu="matMenu">
                            <button mat-menu-item (click)="exportToExcel()">
                                <mat-icon svgIcon="heroicons_outline:arrow-down-tray"></mat-icon>
                                <span>Exportar</span>
                            </button>
                            
                            <!-- New Excel Import Assistant -->
                            <app-import-button
                                [config]="importConfig"
                                [buttonText]="'Importar GPS'"
                                [variant]="{ type: 'mat-menu', color: '' }"
                             >
                            </app-import-button>
                        </mat-menu>
                    </div>
                </div>
            </div>
        </div>
        <div
            class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
            <!-- Main Content (Table and Paginator) -->
            <div class="pt-1 mx-6">
                <!-- Tabla -->
                <div class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
                    <!-- Header -->
                    <div class="overflow-auto flex-1 dark:bg-gray-900">
                        <table class="w-full bg-transparent" mat-table [dataSource]="dataSource" matSort
                            [trackBy]="trackByFn">
                            <!-- Código -->
                            <!-- <ng-container matColumnDef="code">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="pl-10 text-left">Código</th>
                <td mat-cell *matCellDef="let businessPartner" class="pl-10 text-left">{{ businessPartner.code }}</td>
              </ng-container> -->

                            <!-- Ubicación -->
                            <ng-container matColumnDef="addresses">
                                <th mat-header-cell *matHeaderCellDef class="text-left no-padding-cell"></th>
                                <td mat-cell *matCellDef="let row" class="text-center no-padding-cell">
                                    <mat-icon
                                        [color]="(row.addresses?.[0]?.geolocationPoint?.[0] === 0 && row.addresses?.[0]?.geolocationPoint?.[1] === 0) || 
                    !row.addresses?.[0]?.geolocationPoint || row.addresses?.[0]?.geolocationPoint.length == 0 ? 'warn' : 'primary'"
                                        (click)="row.addresses?.[0]?.geolocationPoint && row.addresses?.[0]?.geolocationPoint.length > 0 ? openModal(row.addresses?.[0]): null"
                                        style="cursor: pointer;">location_on</mat-icon>
                                    <!--{{ row.addresses?.[0]?.geolocationPoint?.[0]}}, {{ row.addresses?.[0]?.geolocationPoint?.[1]}}-->
                                </td>
                            </ng-container>
                            <!-- Nombre -->
                            <ng-container matColumnDef="name">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left">
                                    {{ 'BUSINESS_PARTNER.NAME' | transloco }}
                                </th>
                                <td mat-cell *matCellDef="let businessPartner" class="text-sm uppercase leading-tight">

                                    <div *ngIf="businessPartner.externalKeys">
                                        <div *ngIf="getCode(businessPartner) as code">
                                            <b class="f-10">{{ code }}</b>
                                        </div>
                                    </div>
                                    <span class="f-12 uppercase">{{ businessPartner.name }}</span>
                                </td>
                            </ng-container>

                            <!-- Tipo -->
                            <ng-container matColumnDef="type">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left">
                                    {{'BUSINESS_PARTNER.TYPE' | transloco }}
                                </th>
                                <td mat-cell *matCellDef="let businessPartner" class="text-sm uppercase leading-tight">
                                    {{ businessPartner.types[0]?.name || "No asignada" }}
                                </td>
                            </ng-container>

                            <!-- Compañía -->
                            <ng-container matColumnDef="geo">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left">
                                    Dirección
                                </th>
                                <td mat-cell *matCellDef="let businessPartner" class="text-sm uppercase leading-tight">
                                    <div>
                                        <b class="f-10">{{ businessPartner.addresses?.[0]?.externalKeys?.code }}</b>
                                    </div>
                                    <span class="f-12">{{ businessPartner.addresses?.[0]?.address }}</span>
                                </td>
                            </ng-container>

                            <!-- División -->
                            <ng-container matColumnDef="division">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left">
                                    Ruta
                                </th>
                                <td mat-cell *matCellDef="let businessPartner" class="text-sm uppercase leading-tight">
                                    <div>
                                        <b class="f-10">{{
                                            businessPartner.subRouteGeoUpdatePending?.[0]?.externalKeys?.code }}</b>
                                    </div>
                                    <span class="f-12">{{ businessPartner.subRouteGeoUpdatePending?.[0]?.name }}</span>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="createdAt">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left">
                                    Fecha de creación
                                </th>
                                <td mat-cell *matCellDef="let businessPartner" class="text-sm uppercase leading-tight">
                                    {{ businessPartner.createdAt | date: "dd-MM-yyyy" }}
                                </td>
                            </ng-container>

                            <!-- Credit Limit -->
                            <ng-container matColumnDef="creditLimit">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-right">
                                    {{ 'BUSINESS_PARTNER.CREDIT_LIMIT' | transloco }}
                                </th>
                                <td mat-cell *matCellDef="let businessPartner" class="px-6 text-sm uppercase">
                                    {{ businessPartner.creditLimit | moneda }}
                                </td>
                            </ng-container>


                            <!-- Acciones -->
                            <ng-container matColumnDef="actions">
                                <th mat-header-cell *matHeaderCellDef class="px-6 py-3 text-left"></th>
                                <td mat-cell *matCellDef="let businessPartner" class="px-6 py-3 text-left">
                                    <button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones">
                                        <mat-icon>more_vert</mat-icon>
                                    </button>
                                    <mat-menu #actionMenu="matMenu">
                                        <button mat-menu-item (click)="openEditModal(businessPartner)">
                                            <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                                            <span>{{'GENERAL.EDIT' | transloco }}</span>
                                        </button>
                                        <button *ngIf="isAllow(businessPartner)" mat-menu-item
                                            (click)="openSettingUser(businessPartner)">
                                            <mat-icon svgIcon="heroicons_outline:user-circle"></mat-icon>
                                            <span>Conf. Usuario</span>
                                        </button>
                                        <button mat-menu-item (click)="openBPschedule(businessPartner)">
                                            <mat-icon svgIcon="heroicons_outline:calendar-days"></mat-icon>
                                            <span>Horarios de Entrega</span>
                                        </button>
                                        <button mat-menu-item (click)="openDeleteDialog(businessPartner)">
                                            <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                                            <span>{{'GENERAL.DELETE' | transloco }}</span>
                                        </button>
                                    </mat-menu>
                                </td>
                            </ng-container>

                            <!-- Header Row -->
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"
                                class="sticky top-0 z-10 bg-white dark:bg-gray-900">
                            </tr>

                            <!-- Fila principal -->
                            <tr mat-row *matRowDef="let row; columns: displayedColumns" class="border-b"></tr>
                        </table>
                    </div>
                </div>

                <!-- Paginación -->
                <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
                    <mat-paginator class="z-10" [pageSizeOptions]="[50, 100, 150, 200]" showFirstLastButtons
                        [length]="totalItems" [pageSize]="pageSize" (page)="onPageChange($event)">
                    </mat-paginator>
                </div>
            </div>
        </div>
    </div>

    <!-- Filtros -->

    <app-filter (onFilterEvent)="findAllWithCount()" (onCleanEvent)="onClearFilter()" (onPanelOpened)="onRoutesExpanded()">

        <app-dates-filters [form]="form" [showDateCreationRange]="true"></app-dates-filters>

        <app-routes-filters [form]="form" [route]="true" [loadData]="loadRoutesData"></app-routes-filters>
    </app-filter>
</mat-sidenav-container>

<!-- Mensaje de confirmacion -->
<ng-template #corfimDialog let-data>
    <h2 mat-dialog-title>{{data.title}}</h2>
    <mat-dialog-content>{{data.message}}</mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button [mat-dialog-close]="false">{{data.cancelText}}</button>
        <button mat-raised-button color="warn" [mat-dialog-close]="true">{{data.confirmText}}</button>
    </mat-dialog-actions>
</ng-template>